export const pinToStateGendersMap = {
  M: 'mr',
  F: 'ms'
};

export const pepAttributes = [
  'PEP_GROUND_1',
  'PEP_GROUND_2',
  'PEP_GROUND_3',
  'PEP_GROUND_4',
  'PEP_GROUND_5',
  'PEP_GROUND_6',
  'PEP_GROUND_7',
  'PEP_GROUND_8',
  'PEP_GROUND_9'
];
